import { RefObject } from 'react';

const isInViewport = (element: RefObject<Element>, offset = 0) => {
    if (!element.current) return false;
    const top = element.current?.getBoundingClientRect().top;
    return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
};

export default isInViewport;
